<template>
	<div class="main_page">
		<!-- //轮播 -->
		<div class="index-div">
			<div class="block">
        <div class="mc"></div>

				<el-carousel :interval="6000" trigger="click" height="915px" number="15000">

					<el-carousel-item v-for="item in images" :key="item">
  <div class="cback"></div>
						<div class="nexxqbox2" >

							<div style="z-index: 940;" class="nexflashtxt">三维场景<em>/</em>人机交互<em>/</em>移动终端<em>/</em>泛在学习<em>/</em>虚拟实验</div>
							<h4 style="z-index: 940;"><a href="###">什么是MOOLSNET ？</a></h4>
							<h5 style="z-index: 940;">Massive Open Online LabS </h5>
							<div class="nexfgbox nexfgbox1">
								<a @click="al()" target="_blank" class="nexbuys">产品案例</a>
								<a @click="gy()" target="_blank" class="nexreadmore">关于我们</a>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 优势特点 -->
		<!-- <div class="nexadvbox">
			<div class="w1180">
				<div class="nexpubtop">
					<div id="nexpubtop" class="area">
						<div id="framelChD4p" class="frame move-span cl frame-1">
							<div id="framelChD4p_left" class="column frame-1-c">
								<div id="framelChD4p_left_temp" class="move-span temp"></div>
								<div id="portal_block_67" class="block move-span">
									<div id="portal_block_67_content" class="dxb_bc">
										<div class="portal_block_summary">
											<h5>为什么要选择我们的服务</h5>
											<div class="nex_pubsliders"></div>
											<p>我们的目标，借鉴研究经验，在我们的专业服务机构，并在学术界和企业界的合作者。我们投资于思想领袖的发展，以提高我们在市场上的声誉。</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="nexadvinfo">
					<div class="nexadvoffer">
						<i></i>
						<h5>我们提供的服务</h5>
						<div id="nexadvoffer" class="area">
							<div id="framedf7wd7" class="frame move-span cl frame-1">
								<div id="framedf7wd7_left" class="column frame-1-c">
									<div id="framedf7wd7_left_temp" class="move-span temp"></div>
									<div id="portal_block_68" class="block move-span">
										<div id="portal_block_68_content" class="dxb_bc">
											<div class="portal_block_summary">
												<div class="nexadsoffercons">星点互联—精于技术，简于设计。星点互联将复杂的网络设计资源打包成简单的API和SDK，让SaaS厂商和软件开发者可以方便的通过接口嵌入消息、语音、视频、流量、直播、身份验证等。</div>
												<div class="nexadsoffercons">星点互联提供的服务，让客户通过网页、手机app、微信和微博都可以与客服进行即时聊天，客户问题都可以得到最快速的解决。</div>
												<a href="#" target="_blank">点击免费咨询<em></em></a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="nexadvterms">
						<ul>
							<li class="nexadvterm_one">
								<div id="nexadvterms" class="area">
									<div id="frameCz4Z75" class="frame move-span cl frame-1">
										<div id="frameCz4Z75_left" class="column frame-1-c">
											<div id="frameCz4Z75_left_temp" class="move-span temp"></div>
											<div id="portal_block_69" class="block move-span">
												<div id="portal_block_69_content" class="dxb_bc">
													<div class="portal_block_summary">
														<div class="nexadvtermicon nexadvtermicon1"></div>
														<div class="nexadvinfoers">
															<h5>满足不断增长的商业需求</h5>
															<a href="#" target="_blank">了解详情</a>
															<div class="nexadvintros">星点互联阐述了新平台战略及其核心价值。未来星点互联将通过平台开放、在线服务、融合通信、国际布局四大战略的实施，致力于成为面向全球的、中国最大的融合通信、资源与平台服务提供商。</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</li>
							<li class="nexadvterm_two">
								<div id="nexadvterm_two" class="area">
									<div id="frameaFhF22" class="frame move-span cl frame-1">
										<div id="frameaFhF22_left" class="column frame-1-c">
											<div id="frameaFhF22_left_temp" class="move-span temp"></div>
											<div id="portal_block_70" class="block move-span">
												<div id="portal_block_70_content" class="dxb_bc">
													<div class="portal_block_summary">
														<div class="nexadvtermicon nexadvtermicon2"></div>
														<div class="nexadvinfoers">
															<h5>无与伦比的稳定性和可持续性</h5>
															<a href="#" target="_blank">了解详情</a>
															<div class="nexadvintros">稳定性和可持续性是许多企业和组织的优先利益。权威调查表明响应速度和问题一次解决率是影响客户满意度的关键，智能客服系统正是从这两方面入手，覆盖所有渠道提高响应速度，在线客服平台和完善工单系统让更多问题得到一次性解决。</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</li>
							<li class="nexadvterm_three">
								<div id="nexadvterm_three" class="area">
									<div id="frameAHs3WO" class="frame move-span cl frame-1">
										<div id="frameAHs3WO_left" class="column frame-1-c">
											<div id="frameAHs3WO_left_temp" class="move-span temp"></div>
											<div id="portal_block_71" class="block move-span">
												<div id="portal_block_71_content" class="dxb_bc">
													<div class="portal_block_summary">
														<div class="nexadvtermicon nexadvtermicon3"></div>
														<div class="nexadvinfoers">
															<h5>精彩的设计与细致的思考</h5>
															<a href="#" target="_blank">了解详情</a>
															<div class="nexadvintros">近年随着互联网的深入发展，生活日常和互联网紧密相连，各类在线平台和社交软件、支付软件在我们的生活中扮演着重要的角色。在紧急情况下，验证码迟迟收不到。导致软件和平台用户体验差，让用户最终放弃使用。</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</li>
							<li class="nexadvterm_four">
								<div id="nexadvterm_four" class="area">
									<div id="framewlL62p" class="frame move-span cl frame-1">
										<div id="framewlL62p_left" class="column frame-1-c">
											<div id="framewlL62p_left_temp" class="move-span temp"></div>
											<div id="portal_block_72" class="block move-span">
												<div id="portal_block_72_content" class="dxb_bc">
													<div class="portal_block_summary">
														<div class="nexadvtermicon nexadvtermicon4"></div>
														<div class="nexadvinfoers">
															<h5>星点战略开放为产业链赋能</h5>
															<a href="#" target="_blank">了解详情</a>
															<div class="nexadvintros">本次平台战略发布也紧密贴合运营商今年提速降费的核心，在当今经济深化改革的环境下，为供给侧的运营商提供平台服务，为客户翻译转化通信需求，从而快速提供通信供给与需求耦合，提高通信产业与服务效率。</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</li>
							<div class="clear"></div>
						</ul>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		 -->
    <!-- 产品案例 -->
		<div class="nexproducts">
			<div class="w1180">
				<div class="nexpubtop">
					<div id="nexaboutus_R1" class="area">
						<div id="framehJ3hRN" class="frame move-span cl frame-1">
							<div id="framehJ3hRN_left" class="column frame-1-c">
								<div id="framehJ3hRN_left_temp" class="move-span temp"></div>
								<div id="portal_block_76" class="block move-span">
									<div id="portal_block_76_content" class="dxb_bc">
										<div class="portal_block_summary">
											<h5>产品案例</h5>
											<div class="nex_pubsliders"></div>
											<p>个体化、移动端虚拟实验平台，涵盖化学、生物、机械、物理等多领域</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="nex_casebds">
				<!-- 	<div class="nex_casetab">
						<ul>
							<li class="ons">金融服务</li>
							<em>/</em>
							<li class="">投资项目</li>
							<em>/</em>
							<li class="">营销案例</li>
							<em>/</em>
							<li class="">活动方案</li>
							<em>/</em>
							<li class="">定制产品</li>
							<div class="clear"></div>
						</ul>
					</div> -->
					<!-- list -->
					<div class="nex_cases_contents">
						<ul>
							<li style="display: block;">
								<div class="nexcases">
									<div class="dl">
										<!--[diy=nexcases]-->
										<div id="nexcases" class="area">
											<div class="frame move-span cl frame-1">
												<div class="column frame-1-c">
													<div class="move-span temp"></div>
													<div class="block move-span">
														<div class="dxb_bc">
															<div v-for="(item,index) in cplist" class="dd">
																<div class="nex_case_pic">
																	<img :src="item.img" width="280" height="190">
																	<div class="nexoverlaystyle_one">
																		<div class="nexinter_box">
																			<div class="nexover_content">
																				<a @click="shipin(index)"><i></i></a>
																			</div>
																		</div>
																	</div>
																</div>
																<div class="nex_case_inbox">
																	<!-- <span><a href="http://xdqy.lcwluo.top/portal.php?mod=list&amp;catid=5" target="_blank">{{item.span}}</a></span> -->
																	<h5><a >{{item.h5}}</a></h5>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<!--[/diy]-->
										<div class="clear"></div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- 企业新闻动态 -->
<div class="nexnewsbd">
			<div class="w1180">
				<div class="nexpubtop nexpubtopx">
					<!--[diy=nexonboxs1]-->
					<div id="nexonboxs1" class="area">
						<div id="framere6lDb" class="frame move-span cl frame-1">
							<div id="framere6lDb_left" class="column frame-1-c">
								<div id="framere6lDb_left_temp" class="move-span temp"></div>
								<div id="portal_block_84" class="block move-span">
									<div id="portal_block_84_content" class="dxb_bc">
										<div class="portal_block_summary">
											<h4>新闻动态</h4>
											<div class="nex_pubslidersx"></div>
											<!-- <p class="nexpubtopxp ">专家团队洞悉行业内的需求痛点和发展方向，为您灵活定制解决方案的最佳之选</p> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--[/diy]-->

				</div>
				<div class="nexnewsbhj">
					<div  class="nexnewslisted">
						<ul>
							<!--[diy=nexnewslisted]-->
							<div id="nexnewslisted" class="area">
								<div id="framel12REu" class="frame move-span cl frame-1">
									<div id="framel12REu_left" class="column frame-1-c">
										<div id="framel12REu_left_temp" class="move-span temp"></div>
										<div id="portal_block_85" class="block move-span">
											<div id="portal_block_85_content" class="dxb_bc">
												<li v-for="item in getMoolsnetWxArtList11" class="nexnewsmain">
													<div class="nexnews_pic">
														<a :href="item.url" target="_blank">
															<i>企业新闻</i>
															<img :src="item.pic" width="320" height="250">
														</a>
													</div>
													<h5><a :href="item.url" target="_blank">{{item.title}}</a></h5>
													<!-- <div class="nexartscon">2017年已经过去，2018年刚刚开始。这意味着，在这新的一年里，我们将会看到更多全新科</div> -->
												</li>
												<li v-for="item in getMoolsnetWxArtList1" class="nexnewsodds">
													<a :href="item.url" target="_blank">{{item.title}}</a>
													<!-- <em>2018-08-03</em> -->
													<div class="clear"></div>
												</li>


											</div>
										</div>
									</div>
								</div>
							</div>
							<!--[/diy]-->

						</ul>
					</div>
					<div class="nexnewslisted nexnewslisted1">
						<ul>
							<!--[diy=nexnewslisted1]-->
							<div id="nexnewslisted1" class="area">
								<div id="frameXndrT3" class="frame move-span cl frame-1">
									<div id="frameXndrT3_left" class="column frame-1-c">
										<div id="frameXndrT3_left_temp" class="move-span temp"></div>
										<div id="portal_block_86" class="block move-span">
											<div id="portal_block_86_content" class="dxb_bc">
												<li v-for="item in getMoolsnetWxArtList22" class="nexnewsmain">
													<div class="nexnews_pic">
														<a :href="item.url" target="_blank">
															<i>企业新闻</i>
															<img :src="item.pic" width="350" height="220">
														</a>
													</div>
													<h5><a :href="item.url" target="_blank">{{item.title}}</a></h5>
													<!-- <div class="nexartscon">2017年已经过去，2018年刚刚开始。这意味着，在这新的一年里，我们将会看到更多全新科</div> -->
												</li>
												<li v-for="item in getMoolsnetWxArtList2" class="nexnewsodds">
													<a :href="item.url" target="_blank">{{item.title}}</a>
													<!-- <em>2018-08-03</em> -->
													<div class="clear"></div>
												</li>

											</div>
										</div>
									</div>
								</div>
							</div>
							<!--[/diy]-->
						</ul>
					</div>
					<div class="nexnewslisted nexnewslisted2">
						<ul>
							<!--[diy=nexnewslisted2]-->
							<div id="nexnewslisted2" class="area">
								<div id="framev9Ll2x" class="frame move-span cl frame-1">
									<div id="framev9Ll2x_left" class="column frame-1-c">
										<div id="framev9Ll2x_left_temp" class="move-span temp"></div>
										<div id="portal_block_87" class="block move-span">
											<div id="portal_block_87_content" class="dxb_bc">
												<li v-for="item in getMoolsnetWxArtList33" class="nexnewsmain">
													<div class="nexnews_pic">
														<a :href="item.url" target="_blank">
															<i>企业新闻</i>
															<img :src="item.pic" width="350" height="220">
														</a>
													</div>
													<h5><a :href="item.url" target="_blank">{{item.title}}</a></h5>
													<!-- <div class="nexartscon">2017年已经过去，2018年刚刚开始。这意味着，在这新的一年里，我们将会看到更多全新科</div> -->
												</li>
												<li v-for="item in getMoolsnetWxArtList3" class="nexnewsodds">
													<a :href="item.url" target="_blank">{{item.title}}</a>
													<!-- <em>2018-08-03</em> -->
													<div class="clear"></div>
												</li>


											</div>
										</div>
									</div>
								</div>
							</div>
							<!--[/diy]-->
						</ul>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>









    <!-- 产品案例 -->
<!-- 合作伙伴 -->
		<div class="nexourclient" style="margin-top: -150px;margin-bottom: 40px;">
			<div class="w1180">
				<div class="nexpubtop" style="margin-bottom: -20px;">
					<!--[diy=nexprojectbx1]-->
					<div id="nexprojectbx1" class="area">
						<div id="frameq33Zco" class="frame move-span cl frame-1">
							<div id="frameq33Zco_left" class="column frame-1-c">
								<div id="frameq33Zco_left_temp" class="move-span temp"></div>
								<div id="portal_block_90" class="block move-span">
									<div id="portal_block_90_content" class="dxb_bc">
										<div class="portal_block_summary">
											<h5>合作伙伴</h5>
											<div class="nex_pubsliders"></div>
											<!-- <p>星点互联致力于打造国内领先的企业级客服平台，携手多家优秀企业，全方位提升用户体验。</p> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--[/diy]-->

				</div>
				<div class="nexkfqunbx">
					<ul>
						<!--[diy=nexkfqunbx]-->
						<div id="nexkfqunbx" class="area">
							<div id="framenAb6id" class="frame move-span cl frame-1">
								<div id="framenAb6id_left" class="column frame-1-c">
									<div id="framenAb6id_left_temp" class="move-span temp"></div>
									<div id="portal_block_91" class="block move-span">
										<div id="portal_block_91_content" class="dxb_bc">
											<div class="portal_block_summary">
												<li class="new1127">
												<img src="https://www.mools.net/lims/web/OfficialWebsite/images/panner1.png" alt="">

												</li>
												<li class="new1127">
												<img src="https://www.mools.net/lims/web/OfficialWebsite/images/panner2.png" alt="">

												</li>
												<li class="new1127">
												<img src="https://www.mools.net/lims/web/OfficialWebsite/images/panner3.png" alt="">

												</li>
												<li class="new1127">
												<img src="https://www.mools.net/lims/web/OfficialWebsite/images/panner4.png" alt="">

												</li>
								<!-- 		<li class="new1127">
										<img src="https://www.mools.net/lims/web/OfficialWebsite/images/化学1.png" alt="">

										</li>
                    <li class="new1127">
                    <img src="https://www.mools.net/lims/web/OfficialWebsite/images/化学1.png" alt="">

                    </li>
                    <li class="new1127">
                    <img src="https://www.mools.net/lims/web/OfficialWebsite/images/化学1.png" alt="">

                    </li> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!--[/diy]-->


						<div class="clear"></div>
					</ul>
				</div>
			</div>
		</div>







<!-- 服务客户 -->
		<div class="nexourclient">
			<div class="w1180">
				<div class="nexpubtop">
					<!--[diy=nexprojectbx1]-->
					<div id="nexprojectbx1" class="area">
						<div id="frameq33Zco" class="frame move-span cl frame-1">
							<div id="frameq33Zco_left" class="column frame-1-c">
								<div id="frameq33Zco_left_temp" class="move-span temp"></div>
								<div id="portal_block_90" class="block move-span">
									<div id="portal_block_90_content" class="dxb_bc">
										<div class="portal_block_summary">
											<h5>软件下载</h5>
											<div class="nex_pubsliders"></div>
											<!-- <p>星点互联致力于打造国内领先的企业级客服平台，携手多家优秀企业，全方位提升用户体验。</p> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--[/diy]-->

				</div>
				<div class="nexkfqunbx">
					<ul>
						<!--[diy=nexkfqunbx]-->
						<div id="nexkfqunbx" class="area">
							<div id="framenAb6id" class="frame move-span cl frame-1">
								<div id="framenAb6id_left" class="column frame-1-c">
									<div id="framenAb6id_left_temp" class="move-span temp"></div>
									<div id="portal_block_91" class="block move-span">
										<div id="portal_block_91_content" class="dxb_bc">
											<div class="portal_block_summary">
												<li>
													<a class="nexkf1" href="#" target="_blank">
														<em class="nexline1"></em><em class="nexline2"></em><em class="nexline3"></em><em class="nexline4"></em>
													</a>

												</li>
												<li>
													<a class="nexkf2" href="#" target="_blank">
														<em class="nexline1"></em><em class="nexline2"></em><em class="nexline3"></em><em class="nexline4"></em>

													</a>
												</li>
		<li>
													<a class="nexkf3" href="#" target="_blank">
														<em class="nexline1"></em><em class="nexline2"></em><em class="nexline3"></em><em class="nexline4"></em>

													</a>
												</li>
		<li>
													<a class="nexkf4" href="#" target="_blank">
														<em class="nexline1"></em><em class="nexline2"></em><em class="nexline3"></em><em class="nexline4"></em>

													</a>
												</li>
												<li >
																							<a class="nexkf5" href="https://moolsnetapk.oss-cn-beijing.aliyuncs.com/ChemLab_All_0920.zip" target="_blank">
																								<em class="nexline1"></em><em class="nexline2"></em><em class="nexline3"></em><em class="nexline4"></em>

																							</a>
																						</li>


											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!--[/diy]-->


						<div class="clear"></div>
					</ul>
				</div>
			</div>
		</div>

<!-- <v-cebianlan>	</v-cebianlan> -->
<!-- shipin -->

<div class="videonone" v-if="videoxs==1">
  <div class="cha" @click="guan()">
    <img src="https://www.mools.net/lims/web/OfficialWebsite/images/ccll.png" alt="">
  </div>
     <!-- 播放器代码开始 -->
                              <video id="my-video" class="video-js" controls preload="none" width="1000" height="500"
                                     :poster="videospt" data-setup="{}">
                                  <source :src="videosp" type="video/mp4">
                              </video>

</div>

	</div>
</template>
<script>
	import Cebianlan from '../../views/cebianlan/cebianlan.vue'
    import axios from 'axios' // 引用axios
	export default {
		name: 'index',
		data() {
			return {
        getMoolsnetWxArtList:[],
           getMoolsnetWxArtList1:[],
              getMoolsnetWxArtList2:[],
                 getMoolsnetWxArtList3:[],
                 getMoolsnetWxArtList11:[],
                    getMoolsnetWxArtList22:[],
                       getMoolsnetWxArtList33:[],
        videosp:"",
        videospt:"",
        videoxs:0,
				images: [
					"http://www.mools.net/lims/web/OfficialWebsite/index/one1.jpg",
					"http://www.mools.net/lims/web/OfficialWebsite/index/two2.jpg",
					"http://www.mools.net/lims/web/OfficialWebsite/index/three3.jpg"
				],
				cplist: [{
						img: "https://www.mools.net/lims/web/OfficialWebsite/images/化学1.png",
						span: "",
						h5: "催化剂的制备与表征"
					},
					{
						img: "https://www.mools.net/lims/web/OfficialWebsite/images/生物1.png",
						span: "企业新闻",
						h5: "生物化学、微生物、分子生物学"
					},
					{
						img: "https://www.mools.net/lims/web/OfficialWebsite/images/物理3.png",
						span: "活动方案",
						h5: "大学物理实验"
					},
{
						img: "https://www.mools.net/lims/web/OfficialWebsite/images/机械4.png",
						span: "活动方案",
						h5: "机械加工系列"
					}
				]

			}
		},
		components:{
			'v-cebianlan':Cebianlan
		},
		methods: {
      al(){
        	this.$router.push('/home/community')
      },
      gy(){
        this.$router.push('/home/about/companyProfile')
        window.sessionStorage.setItem("curyes", 0);
      },
      guan(){
        var that = this;
        that.videoxs = 0;
      },
      shipin(index){
        var that = this;
        that.videoxs = 1;
        console.log(index)
        // 化学：https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/ZMS5.mp4
        // 机械：https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E6%9C%BA%E6%A2%B0.mp4
        // 物理：https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E7%89%A9%E7%90%861.mp4
        // 生物化学：https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E7%94%9F%E7%89%A9%E5%8C%96%E5%AD%A6.mp4
        if(index==0){
          that.videosp = "https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/ZMS5.mp4"
          that.videospt = "https://www.mools.net/lims/web/OfficialWebsite/images/化学1.png";
        }
        if(index==1){
          that.videosp = "https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E7%94%9F%E7%89%A9%E5%8C%96%E5%AD%A6.mp4"
          that.videospt = "https://www.mools.net/lims/web/OfficialWebsite/images/生物1.png";
        }
        if(index==2){
          that.videosp = "https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E7%89%A9%E7%90%861.mp4"
          that.videospt = "https://www.mools.net/lims/web/OfficialWebsite/images/物理3.png";
        }
        if(index==3){
          that.videosp = "https://moolsnetvideo.oss-cn-beijing.aliyuncs.com/%E6%9C%BA%E6%A2%B0.mp4"
          that.videospt = "https://www.mools.net/lims/web/OfficialWebsite/images/机械4.png";
        }
      },
			opt: function(str) {
				this.login_show = true
				this.dialog_item = str
			},
			goHome: function() {
				this.$router.push("/")
			},
			info: function(message) {
				if (message == 'regist') {
					this.login_show = true
					this.dialog_item = message
				}
			},
			showItem: function() {
				this.show_item = !this.show_item;
			},
			outItem: function() {
				this.show_item = false;
			},
			community: function() {
				this.$router.push('/home/community')
			},
			goRouter: function(url) {
				this.$router.push(url)
			},
			handleClose(done) {
				// 						this.$confirm('确认关闭？').then(_ => {
				//             done();
				//           })
				//           .catch(_ => {});
			},
			handleScroll() { //改变元素#searchBar的top值
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// var offsetTop = document.querySelector('.home-div').offsetTop;
				if (scrollTop > 1) {
					// document.querySelector('.home-div').style.background = "#000";
					// document.querySelector('.home-div').style.opacity = 0.5;
					document.querySelector('.nex_topgt').style.display = "none";

					// alert(111)
					document.getElementById("nexheader").classList.add("nex_subtops");


				} else {
					document.getElementById("nexheader").classList.remove("nex_subtops");
					// document.querySelector('.home-div').style.background = "unset"
					document.querySelector('.nex_topgt').style.display = "block";
				}
			},
		},
		mounted() { //给window添加一个滚动滚动监听事件
			window.addEventListener('scroll', this.handleScroll)
      var that = this;
      //通过给定的ID来发送请求
      axios.get("https://www.mools.net/lims/api/laravel/public/index.php/getMoolsnetWxArtList")
        .then(function(response){
          that.getMoolsnetWxArtList = response.data.data;
          for(var i=0;i<response.data.data.length;i++){
            if(i==3||i==6||i==9||i==12||i==15||i==18){
              that.getMoolsnetWxArtList1.push(response.data.data[i])
            }
            if(i==4||i==7||i==10||i==13||i==16||i==19){
                that.getMoolsnetWxArtList2.push(response.data.data[i])
            }
            if(i==5||i==8||i==11||i==14||i==17){
                that.getMoolsnetWxArtList3.push(response.data.data[i])
            }
            if(i==0){
              that.getMoolsnetWxArtList11.push(response.data.data[i])
            }
            if(i==1){
              that.getMoolsnetWxArtList22.push(response.data.data[i])
            }
            if(i==2){
              that.getMoolsnetWxArtList33.push(response.data.data[i])
            }
          }
          console.log( that.getMoolsnetWxArtList1);
          console.log( that.getMoolsnetWxArtList2);
          console.log( that.getMoolsnetWxArtList3);
           console.log( that.getMoolsnetWxArtList11);
            console.log( that.getMoolsnetWxArtList22);
             console.log( that.getMoolsnetWxArtList33);
        })
        .catch(function(err){
          console.log(err);
        });
		},
		destroyed() { //离开该页面需要移除这个监听的事件
			window.removeEventListener('scroll', this.handleScroll)
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .new1127{
    width: 270px;
    float: left;
    margin-right: 30px;
  }
  .new1127 img{
    border: 1px #ede6e6 solid;
    width: 270px;
    height: 100px;
  }
.cback{
    position: absolute;
    top: 276px;
    left: 50%;
    background-color: #000000;
    /* z-index: 888; */
    opacity: 0.3;
    /* margin: 276px auto 0 auto; */
    border-radius: 20px;
    /* left: 264px; */
    width: 1180px;
    margin-left: -590px;
    height: 350px;
}
  .mc{
  		width: 100%;
  		height: 107px;
  		position: absolute;
  		top: 0;
  		left: 0;
  		background-color: #000000;
  		z-index: 888;
  		opacity:0.3;
  	}

.cha{
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
/*  width: 20px;
  height: 20px;
  background-color: #0095FF; */
}
.videonone  {
      /* 写样式时尽量先写定位哦，有利于页面渲染 */
      position: fixed;
      top:50%;
      left: 50%;
      margin:-250px 0 0 -500px;
      /* 这里宽高写成了px，要是百分比就直接差值除以二就可以啦，不用再多一步margin */
      width: 1000px;
      height: 500px;
      background: #000000;
z-index: 999;
}
	/* 服务客户 */
	.nexourclient {
		width: 100%;
		min-width: 1180px;
		/* padding: 40px 0; */
		position: relative;
		background: #fff;
	}

	.nexpubtop {
		margin-bottom: 40px;
	}

	.nexpubtop h5 {
		text-align: center;
		font-size: 34px;
		color: #434343;
		font-weight: 300;
		/* height: 40px; */
		line-height: 40px;
		/* overflow: hidden; */
	}

	.nex_pubsliders {
		text-align: center;
		position: relative;
		margin: 25px 0;
		height: 2px;
	}

	.nex_pubsliders:before {
		content: '';
		position: absolute;
		width: 132px;
		height: 2px;
		left: 50%;
		bottom: 0;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		background: #0095FF;
	}

	.nex_pubsliders:after {
		content: '';
		width: 32px;
		height: 2px;
		position: absolute;
		left: 50%;
		bottom: 0;
		border-left: 10px solid #fff;
		border-right: 10px solid #fff;
		-webkit-animation: nexsliderbar 5s linear infinite;
		animation: nexsliderbar 5s linear infinite;
		background: #0095FF;
	}

	.nexpubtop p {
		width: 800px;
		margin: 0 auto;
		font-size: 14px;
		color: #aaa;
		line-height: 25px;
		text-align: center;
	}

	.nexkfqunbx {
		margin-top: 30px;
	}

	.nexkfqunbx ul {
		width: 1205px;
	}

	.nexkfqunbx ul li a.nexkf1 {
		background: #fff url(https://www.mools.net/lims/web/OfficialWebsite/img/应用宝.png) center no-repeat;
    background-size: 100% 100%;
	}
/* .main_page {
    min-width: 1920px;
    margin: 0 auto;
    min-height: 60px;
} */
	.nexkfqunbx ul li a em {
		position: absolute;
		width: 1px;
		height: 1px;
		z-index: 5;
		background: #0095FF;
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nexkfqunbx ul li a em.nexline1 {
		top: 0;
		left: -100%;
		width: 100%;
	}

	.nexkfqunbx ul li a em.nexline2 {
		bottom: -100%;
		right: 0;
		height: 100%;
	}

	.nexkfqunbx ul li a em.nexline3 {
		bottom: 0;
		right: -100%;
		width: 100%;
	}

	.nexkfqunbx ul li a em.nexline4 {
		top: -100%;
		left: 0;
		height: 100%;
	}

	.nexkfqunbx ul li a.nexkf2 {
		background: #fff url(https://www.mools.net/lims/web/OfficialWebsite/img/华为.png) center no-repeat;
    background-size: 100% 100%;
	}
	.nexkfqunbx ul li a.nexkf3 {
		background: #fff url(https://www.mools.net/lims/web/OfficialWebsite/img/小米.png) center no-repeat;
    background-size: 100% 100%;
	}
  .nexkfqunbx ul li a.nexkf4 {
  	background: #fff url(https://www.mools.net/lims/web/OfficialWebsite/img/苹果.png) center no-repeat;
     background-size: 100% 100%;
  }
 .nexkfqunbx ul li a.nexkf5 {
  	background: #fff url(https://www.mools.net/lims/web/OfficialWebsite/img/windows.png) center no-repeat;
     background-size: 100% 100%;
  }
	.nexkfqunbx ul li a {
	     float: left;
	     margin: 0 50px 15px 0;
	     display: block;
	     width: 180px;
	     height: 180px;
	     border: 1px solid #efefef;
	     position: relative;
	     overflow: hidden;
	}

		.nexover_content a i {
		display: block;
		width: 40px;
		height: 40px;
		 background: #0095FF url(http://www.mools.net/lims/web/OfficialWebsite/exam/link.png) center no-repeat;
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nexover_content a i:hover {
		transform: scale(1.2);
		-moz-transform: scale(1.2);
		-webkit-transform: scale(1.2);
		-o-transform: scale(1.2);
		-ms-transform: scale(1.2);
	}

	.nex_case_pic:hover .nexoverlaystyle_one {
		opacity: 1;
		-webkit-transform: perspective(400px) rotateX(0deg);
		-moz-transform: perspective(400px) rotateX(0deg);
		-ms-transform: perspective(400px) rotateX(0deg);
		-o-transform: perspective(400px) rotateX(0deg);
		transform: perspective(400px) rotateX(0deg);
	}
		.nex_case_pic img {
		width: 280px;
		height: 190px;
		transform: scale(1, 1);
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nex_case_pic:hover img {
		transform: scale(1.1, 1.1);
	}










	/* 企业新闻 */
	.nexpubtopxp {
    color: #fff!important;
}
	.nexnewsbd {
		width: 100%;
		min-width: 1180px;
		position: relative;
		height: 880px;
		padding-top: 40px;
		background: url(http://www.mools.net/lims/web/OfficialWebsite/images/xwdt.png) 0 0 no-repeat;
	}

	.nexpubtop {
		margin-bottom: 40px;
	}

	.nexpubtop h4 {
		text-align: center;
		font-size: 34px;
		color: #fff;
		font-weight: 300;
		height: 40px;
		line-height: 40px;
		overflow: hidden;
	}

	.nex_pubslidersx {
		text-align: center;
		position: relative;
		margin: 25px 0;
		height: 2px;
	}

	.nex_pubslidersx:before {
		content: '';
		position: absolute;
		width: 132px;
		height: 2px;
		left: 50%;
		bottom: 0;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		background: #fff;
	}

	.nex_pubslidersx:after {
		content: '';
		width: 32px;
		height: 2px;
		position: absolute;
		left: 50%;
		bottom: 0;
		border-left: 10px solid #fff;
		border-right: 10px solid #fff;
		-webkit-animation: nexsliderbar 5s linear infinite;
		animation: nexsliderbar 5s linear infinite;
		background: #0095FF;
	}

	.nexpubtop p {
		width: 800px;
		margin: 0 auto;
		font-size: 14px;
		color: #aaa;
		line-height: 25px;
		text-align: center;
	}

	.nexpubtopx p {
		color: #fff;
	}

	.nexnewsbhj {
		width: 1180px;
		height: 642px;
		background: #fff;
		position: relative;
		top: 10px;
		-moz-box-shadow: 0 0 74px rgba(12, 12, 12, 0.07);
		-webkit-box-shadow: 0 0 74px rgba(12, 12, 12, 0.07);
		box-shadow: 0 0 74px rgba(12, 12, 12, 0.07);
	}

	.nexnewslisted {
		    width: 352px;
    float: left;
    padding: 0 20px;
    margin: 20px 0;
    border-right: 1px solid #efefef;
    height: 600px;
	}

	.nexnewslisted ul li.nexnewsmain {
		border-bottom: 1px dashed #ededed;
		padding-bottom: 15px;
		margin-bottom: 10px;
	}

	.nexnews_pic {
		width: 352.6px;
		height: 200px;
	}

	.nexnews_pic a {
		display: block;
		width: 352.6px;
		height: 200px;
		position: relative;
	}

	.nexnews_pic a i {
		display: block;
		width: 60px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		background: #0095FF;
		overflow: hidden;
		position: absolute;
		top: 15px;
		left: 15px;
	}

	em,
	cite,
	i {
		font-style: normal;
	}

	.nexnews_pic a img {
		width: 352.6px;
		height: 200px;
	}

	.nexnewslisted ul li.nexnewsmain h5 {
		height: 25px;
		line-height: 25px;
		overflow: hidden;
		margin: 10px 0;
	}

	.nexnewslisted ul li.nexnewsmain h5 a {
		font-size: 16px;
		color: #434343;
		font-weight: 400;
	}

	.nexartscon {
		height: 48px;
		line-height: 24px;
		font-size: 12px;
		color: #999;
		overflow: hidden;
	}

	.nexnewslisted ul li.nexnewsodds {
		height: 38px;
		line-height: 38px;
		overflow: hidden;
	}

	.nexnewslisted ul li.nexnewsodds a {
		display: inline-block;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
		color: #434343;
		float: left;
		width: 240px;
		overflow: hidden;
	}

	.nexnewslisted ul li.nexnewsodds em {
		display: inline-block;
		height: 38px;
		line-height: 38px;
		font-size: 12px;
		color: #999;
		float: right;
	}

	/* 产品案例 */
	.nexproducts {
		width: 100%;
		min-width: 1180px;
		padding: 40px 0;
		background: #F5F5F5 url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/case_bg.jpg) 0 0 no-repeat;
	}

	.nexpubtop {
		margin-bottom: 40px;
	}

	.nexadvinfo {
		height: 400px;
	}

	.nexpubtop p {
		width: 800px;
		margin: 0 auto;
		font-size: 14px;
		color: #aaa;
		line-height: 25px;
		text-align: center;
	}

	.cl:after {
		content: ".";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}

	.nex_casetab ul {
		display: table;
		margin: 0 auto;
	}

	.nex_casetab ul li {
		float: left;
		font-size: 14px;
		color: #666;
		font-weight: 300;
		cursor: pointer;
		letter-spacing: 2px;
	}

	.nex_casetab ul em {
		display: block;
		float: left;
		margin: 0 15px;
		font-size: 14px;
		color: #999;
		font-weight: 300;
	}

	.nex_cases_contents {
		margin-top: 30px;
	}

	.nexcases .dl {
		width: 1220px;
	}

	.frame-1-c {
		background-color: transparent !important;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.nexcases .dl .dd {
		float: left;
		margin: 0 20px 20px 0;
		width: 280px;
		cursor: pointer;
	}

	.nex_case_pic {
		width: 280px;
		height: 190px;
		overflow: hidden;
		position: relative;
	}

	.nex_case_pic img {
		width: 280px;
		height: 190px;
		transform: scale(1, 1);
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	img {
		border: none;
	}

	.nexoverlaystyle_one {
		position: absolute;
		background: rgba(0, 0, 0, 0.6);
		height: 100%;
		left: 0;
		top: 0;
		width: 100%;
		opacity: 0;
		text-align: center;
		-webkit-transform: perspective(400px) rotateX(-90deg);
		-moz-transform: perspective(400px) rotateX(-90deg);
		-ms-transform: perspective(400px) rotateX(-90deg);
		-o-transform: perspective(400px) rotateX(-90deg);
		transform: perspective(400px) rotateX(-90deg);
		-webkit-transform-origin: top;
		-moz-transform-origin: top;
		-ms-transform-origin: top;
		-o-transform-origin: top;
		transform-origin: top;
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-o-transition: all 0.5s;
		transition: all 0.5s;
	}

	.nexinter_box {
		display: table;
		height: 100%;
		width: 100%;
	}

	.nexover_content {
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.nexover_content a {
		opacity: 1;
		border: 1px solid #0095FF;
		display: inline-block;
		width: 40px;
		height: 40px;
		border-radius: 3px;
		font-size: 15px;
		line-height: 40px;
		transition: all 500ms ease;
		background: #0095FF;
	}

	.nexover_content a i {
		display: block;
		width: 40px;
		height: 40px;
		background: #0095FF url(http://www.mools.net/lims/web/OfficialWebsite/img/vi.png) center no-repeat;
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nex_case_inbox {
		padding: 10px 15px;
		background: #fff;
	}

	.nex_case_inbox span {
		display: block;
		height: 20px;
		line-height: 20px;
		margin-bottom: 5px;
		overflow: hidden;
		padding-left: 20px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/from.png) left center no-repeat;
	}

	.nex_case_inbox span a {
		font-size: 12px;
		color: #CBCBCB;
	}

	.nex_case_inbox h5 {
		height: 50px;
		line-height: 25px;
		overflow: hidden;
	}

	.nex_case_inbox h5 a {
		font-size: 16px;
		color: #434343;
		font-weight: 400;
	}




	.clear {
		clear: both;
	}

	.index-div3-div {
		opacity: 0;
		/* display: none; */
	}

	/* 优势特点 */
	.w1180 {
		width: 1180px;
		margin: 0 auto;
	}

	.nexadvbox {
		width: 100%;
		min-width: 1180px;
		padding: 0 0 40px 0;
		margin-top: 60px;
	}

	.nexpubtop {
		margin-bottom: 40px;
	}

	.move-span {
		background: none;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.frame-1 {
		background-color: transparent !important;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.frame,
	.frame-tab {
		margin-bottom: 10px;
		border: 1px solid #ededed;
		background: #FFF;
	}

	.cl {
		zoom: 1;
	}

	.frame-1-c {
		background-color: transparent !important;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	/* .nexpubtop h5 {
		text-align: center;
		font-size: 34px;
		color: #434343;
		font-weight: 300;
		height: 40px;
		line-height: 40px;
		overflow: hidden;
	} */

	.nex_pubsliders {
		text-align: center;
		position: relative;
		margin: 25px 0;
		height: 2px;
	}

	.nex_pubsliders:before {
		content: '';
		position: absolute;
		width: 132px;
		height: 2px;
		left: 50%;
		bottom: 0;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		background: #0095FF;
	}

	.nex_pubsliders:after {
		content: '';
		width: 32px;
		height: 2px;
		position: absolute;
		left: 50%;
		bottom: 0;
		border-left: 10px solid #fff;
		border-right: 10px solid #fff;
		-webkit-animation: nexsliderbar 5s linear infinite;
		animation: nexsliderbar 5s linear infinite;
		background: #0095FF;
	}

	.nexpubtop p {
		width: 800px;
		margin: 0 auto;
		font-size: 14px;
		color: #aaa;
		line-height: 25px;
		text-align: center;
	}

	.cl:after {
		content: ".";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}

	.nexadvoffer {
		float: left;
		position: relative;
		width: 226px;
		border: 2px solid #ededed;
		background: #fff;
		padding: 20px;
	}

	.nexadvoffer i {
		display: block;
		width: 3px;
		height: 30px;
		background: #0095FF;
		position: absolute;
		top: 26px;
		left: -2px;
	}

	.nexadvoffer h5 {
		height: 40px;
		line-height: 40px;
		overflow: hidden;
		font-size: 20px;
		color: #434343;
		font-weight: 400;
		letter-spacing: 2px;
		margin-bottom: 25px;
	}

	.frame-1-c {
		background-color: transparent !important;
		background-image: none !important;
		border: 0 none !important;
		margin: 0 !important;
		padding: 0 !important;
		border-width: 0px;
		height: auto;
	}

	.nexadsoffercons {
		font-size: 12px;
		color: #999999;
		line-height: 24px;
		font-weight: 400;
		margin-bottom: 12px;
	}

	.nexadsoffercons {
		font-size: 12px;
		color: #999999;
		line-height: 24px;
		font-weight: 400;
		margin-bottom: 12px;
	}

	.nexadvoffer a {
		display: block;
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #0095FF;
		font-weight: 500;
		letter-spacing: 2px;
	}

	.nexadvoffer a em {
		display: inline-block;
		width: 11px;
		height: 10px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/emright.png) no-repeat;
		-webkit-transition: all 0.3s linear;
		-moz-transition: all 0.3s linear;
		-o-transition: all 0.3s linear;
		-ms-transition: all 0.3s linear;
		transition: all 0.3s linear;
	}

	.nexadvterms {
		float: right;
		width: 880px;
	}

	.nexadvterms ul {
		width: 888px;
	}

	.nexadvterms ul li {
		float: left;
		padding: 27px 25px;
		width: 390px;
		height: 132px;
	}

	.nexadvterms ul li.nexadvterm_one {
		border-bottom: 1px solid #ededed;
		border-right: 1px solid #ededed;
	}

	.nexadvtermicon1 {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/icon1.png) center no-repeat;
	}

	.nexadvtermicon {
		width: 55px;
		height: 55px;
		float: left;
	}

	.nexadvinfoers {
		float: right;
		width: 305px;
	}

	.nexadvinfoers h5 {
		height: 20px;
		line-height: 20px;
		overflow: hidden;
		color: #434343;
		font-size: 20px;
		font-weight: 400;
	}

	.nexadvinfoers a {
		display: block;
		color: #0095FF;
		font-size: 14px;
		height: 30px;
		line-height: 30px;
		margin: 5px 0;
		font-weight: 400;
	}

	.nexadvintros {
		font-size: 12px;
		color: #999;
		height: 72px;
		overflow: hidden;
		line-height: 24px;
		font-weight: 400;
	}

	.nexadvterms ul li.nexadvterm_two {
		border-bottom: 1px solid #ededed;
	}

	.nexadvtermicon2 {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/icon2.png) center no-repeat;
	}

	.nexadvterms ul li.nexadvterm_three {
		border-right: 1px solid #ededed;
	}

	.nexadvtermicon3 {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/icon3.png) center no-repeat;
	}

	.nexadvtermicon4 {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/index/icon4.png) center no-repeat;
	}

	/* //轮播内文字 */
	.nexflashtxt em {
		padding: 0 10px;
		font-weight: 300;
	}

	.nexxqbox2 {
      width: 1180px;
      height: 500px;
      margin: 300px auto 0 auto;
      position: relative;
      z-index: 1062;
	}

	.nexxqbox2 .nexflashtxt {
		font-size: 20px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin-bottom: 10px;
		color: #fff;
		font-weight: 300;
	}

	.nexxqbox2 h4 a {
		display: block;
		font-size: 70px;
		width: 780px;
		margin: 0 auto;
		font-weight: 400;
		color: #fff;
		height: 90px;
		line-height: 90px;
		margin-bottom: 20px;
		overflow: hidden;
		padding-left: 100px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/flash/play.png) left center no-repeat;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.nexxqbox2 h5 {
		font-size: 20px;
		line-height: 40px;
		font-weight: 400;
		color: #fff;
		text-align: center;
	}

	.nexfgbox1 {
		display: table;
		margin: 40px auto;
	}

	.nexfgbox a.nexbuys {
		background: none;
		border: 2px solid #fff;
		height: 39px;
		line-height: 39px;
		color: #fff;
	}

	.nexfgbox a.nexreadmore {
		background: #0095FF;
		color: #fff;
	}

	.nexfgbox a {
		display: inline-block;
		width: 143px;
		height: 43px;
		line-height: 43px;
		text-align: center;
		font-size: 14px;
		color: #fff;
		margin-right: 15px;
		letter-spacing: 1px;
	}


	/* // */
	.imglunbo {
		width: 100%;
		height: 915px;
		z-index: 9999999;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
    width: ;
		background-image: url(http://www.mools.net/lims/web/OfficialWebsite/index/banner1.png);
    background-repeat:no-repeat;
       background-size: 100% 100%;

	}

	.el-carousel__item:nth-child(2n+1) {
		background-image: url(http://www.mools.net/lims/web/OfficialWebsite/index/banner2.png);
      background-repeat:no-repeat;
             background-size:  100% 100%;
	}

	.el-carousel__item:nth-child(3) {
        min-width: 1450px;
		background-image: url(http://www.mools.net/lims/web/OfficialWebsite/index/banner3.png);
      background-repeat:no-repeat;
          background-size:  100% 100%;
	}

	.main_page {
		/* min-width: 1619px; */
		margin: 0 auto;
	}

	.el-carousel__container {
		height: 915px;
		width: 100%;
		position: relative;
		background-color: #000;
	}

	.block {
		/* 	height: 915px;
			width: 100%;
			position: relative; */
		/* background-color: #000; */
	}

	.index-div {
		height: 915px;
		width: 100%;
		position: relative;
		background-color: #000;
	}

	.index-div video {
		width: 100%;
		height: 100%;
		object-fit: fill;
		position: absolute;
	}

	.index-div-div {
		width: 700px;
		margin: 0 auto;
		position: relative;
	}

	.index-div-div h1 {
		margin-top: 150px;
		color: #fff;
		font-weight: 500;
		font-size: 32px;
		font-family: myFont;
		display: inline-block;
	}

	.index-div-div .index-div-img {}

	.index-div-div button {
		width: 127px;
		height: 38px;
		border: solid rgba(250, 250, 250, 1) 2px;
		background-color: unset;
		border-radius: 20px;
		color: #fff;
		margin: 0 auto;
		margin-top: 100px;
		display: block;
	}

	.index-div-div button:hover {
		background-color: #fafafa;
		color: #000;
		transition: color 0.4s ease 0s;
		transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
	}

	.index-div-div .index-div-img1 {
		margin-top: 50px;
	}

	.index-div1 {
		width: 350px;
		margin: 0 auto;
		padding-top: 80px;
		margin-bottom: 80px;
	}

	.index-div1 img {
		margin-left: 56px;

	}

	.index-div1 h1 {
		font-weight: 500;
		font-family: myFont;
		color: #464646;
		font-size: 25px;
	}

	.index-div2 {
		width: 100%;
		margin: 0 auto;

	}

	.index-div2 ul {
		width: 1024px;
		margin: 0 auto;
		display: flex;
	}

	.index-div2 ul li {
		/* float: left; */
	}

	.index-div2 ul li:nth-child(2) {
		margin-left: 50px;
	}

	.index-div2 .index-div2-li {
		width: 530px;
		border-radius: 15px;
		background-color: rgba(50, 50, 50, 1);
		/* padding: 30px;
			padding-left: 50px;
			padding-right: 50px; */
		border: 0px solid rgba(153, 153, 151, 1);
		box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
	}

	.index-div2 .index-div2-li .index-div2-img {
		margin-bottom: 30px;
	}

	.index-div2 .index-div2-li figure {
		height: 480px;
		margin-top: 20px;
		padding: 0 50px 0 50px;
	}

	.index-div2 .index-div2-li figure video {
		width: 100%;
		height: 100%;
		object-fit: fill
	}

	.index-div2 .index-div2-li figcaption {
		background-color: #fff;
		padding: 30px;
		/* border-radius: 0 0 20px 20px; */
		height: auto;
	}

	.index-div2 .index-div2-li figcaption h2 {
		text-align: center;
		margin-bottom: 30px;
		font-size: 15px;
		font-weight: 500;
		color: #414141;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.index-div2 .index-div2-li figcaption .index-figure-div1 {
		display: flex;

	}

	.index-div2 .index-div2-li figcaption .index-figure-div1 p {
		width: 60%;
		height: 108px;
		margin-right: 30px;
		line-height: 18px;
		color: #414141;
		-webkit-line-clamp: 6;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.index-div2 .index-div2-li .index-div2-button {
		background-color: unset;
		padding: 10px 40px;
		border: 2px solid #fff;
		color: #fff;
		border-radius: 20px;
		margin-top: 20px;
		margin-left: 175px;
		margin-bottom: 20px;
	}

	.index-div2 .index-div2-li .index-div2-button:hover {
		border-color: rgba(48, 213, 200, 1);
		color: rgba(48, 213, 200, 1);
		transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
	}

	.index-div2 .index-div2-li1 {
		border: 0px solid rgba(153, 153, 151, 1);
		background-color: rgba(250, 250, 250, 1);
		border-radius: 15px 15px 15px 15px;
		box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
	}

	.index-div2 .index-div2-li1 .index-div2-button1 {
		border: solid rgba(65, 65, 65, 1) 2px;
		color: rgba(65, 65, 65, 1);
	}

	.index-div2 .index-div2-li .index-div2-button1:hover {
		border-color: #f60;
		color: #f60;
	}

	.index-div2 .index-div2-li1 .index-div2-li1-figc {
		background-color: rgba(50, 50, 50, 1);
	}

	.index-div2 .index-div2-li1 .index-div2-li1-figc .index-div2-figc-h2 {
		color: #C0C0C0;
	}

	.index-div2 .index-div2-li1 .index-div2-li1-figc .index-div2-li1-p {
		color: #999997;
	}

	.index-div2 .index-div2-li1 .index-div2-li1-img {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.index-div2 .index-div2-li .index-div2-li_title {
		margin-top: 20px;
		padding: 0 40px 0 40px;
	}

	.index-div2 .index-div2-li .index-div2-li_title p {
		font-family: lato-light, lato, sans-serif;
		font-size: 30px;
		color: #fff;
	}

	.index-div2 .index-div2-li .index-div2-li_title_right p {
		font-family: lato-light, lato, sans-serif;
		font-size: 22px;
		color: #000;
	}

	.index-div2 .index-div2-li .index-div2-li_title_right p span {
		font-family: lato-light, lato, sans-serif;
		font-size: 30px;
		color: #000;
	}



	.experience_box {
		width: 500px;
		margin: 0 auto;
		margin-top: 60px;
	}

	.experience_box .experience_box_top p:first-child {
		font-size: 28px;
		color: #565656;
		font-family: myFont;
	}

	.experience_box .experience_box_top p:nth-child(2) {
		width: 280px;
		margin: 0 auto;
		font-size: 40px;
		color: #323232;
		font-family: myFont2;
		text-align: center;
	}

	.experience_box .experience_box_top p:nth-child(2) span {
		display: flex;
		width: 60px;
		height: 4px;
		float: right;
		margin-top: -4px;
		margin-right: 6px;
		background-color: #E91926;
	}

	.experience_box .experience_box_top p:nth-child(3) {
		margin-top: 30px;
		padding: 10px;
		font-size: 18px;
		color: #565656;
		font-family: myFont;
		text-align: left;
	}

	.experience_list {
		width: 1024px;
		margin: 0 auto;
	}

	.experience_list ul {
		width: 980px;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		zoom: 1
	}

	.experience_list ul li {
		width: 980px;
		height: 317px;
		margin-top: 150px;
	}

	.experience_list ul li .experience_font {
		width: 350px;
		position: absolute;
	}

	.experience_list ul li .experience_font p:first-child {
		margin-top: 100px;
		font-size: 40px;
		font-family: myFont2;
		color: #464646;
	}

	.experience_list ul li .experience_font p:first-child span {
		display: flex;
		width: 60px;
		height: 4px;
		float: left;
		position: absolute;
		margin-top: 40px;
		background-color: #E91926;
	}

	.experience_list ul li .experience_font p:nth-child(2) {
		width: 280px;
		margin-top: 20px;
		font-size: 18px;
		font-family: myFont;
		color: #414141;
	}

	.experience_list ul li .experience_img {
		float: right;
	}

	.experience_list ul li .experience_img img {
		height: 317px;
	}

	.experience_list ul li:nth-child(2n) .experience_font {
		float: right;
		position: relative;
	}

	.experience_list ul li:nth-child(2n) .experience_img {
		position: absolute;
	}
</style>



// WEBPACK FOOTER //
// src/components/content/index.vue